import dayjs from 'dayjs';

const today = dayjs();
const tomorrow = today.add(1, 'day');

const filterDates = {
  today: {
    date: today.toDate(),
    formatted: today.format('YYYY-MM-DD'),
  },
  tomorrow: {
    date: tomorrow.toDate(),
    formatted: tomorrow.format('YYYY-MM-DD'),
  },
};

export default filterDates;
